<template>
  <div class="faq-page">
    <menuBar />

    <main class="faq-container">
      <!--
        FAQ content stays as semantic HTML so document formatting can be adjusted directly.
        FAQ 内容保留为语义化 HTML，便于直接调整文档格式和层级。
      -->
      <template v-if="isChinese">
        <header class="faq-hero">
          <p class="faq-meta">10 个常见问题｜约 15 分钟阅读</p>
          <h1>开启 SCAD 之旅</h1>
          <h2>国际学生常见问题快速导览</h2>
          <div class="faq-introduction-desktop">
            <p class="faq-introduction">
              前往海外开启大学生活，是令人期待的人生新篇章，也伴随着种种未知与疑问。从行前准备、初到校园，到学业发展与职业规划，本指南都将陪伴你走过每一个重要阶段。它将帮助你清晰了解入学前需要完成的准备，以及抵达校园后可以获得的各项支持，助你从容开启在
              SCAD 的求学之旅。
            </p>
          </div>
          <p class="faq-introduction faq-introduction-mobile">
            <span>前往海外开启大学生活，</span>
            <span>是令人期待的人生新篇章，</span>
            <span>也伴随着种种未知与疑问。</span>
            <span>无论你是正与孩子一同规划赴美的家长，</span>
            <span>还是即将迎来在 SCAD 第一个学期的学生，</span>
            <span>从行前准备、初到校园，到学业发展与职业规划，</span>
            <span>本指南都将陪伴你走过每一个重要阶段。</span>
            <span>它将帮助你清晰了解入学前需要完成的准备，</span>
            <span>以及抵达校园后可以获得的各项支持，</span>
            <span>助你从容开启在 SCAD 的求学之旅。</span>
          </p>
        </header>

        <nav class="faq-navigation" aria-label="快速导览">
          <h2>快速导览</h2>
          <ol>
            <li>
              <a href="#before-you-leave">
                <span class="nav-number">1</span>
                <span>
                  <strong>行前准备</strong>
                  <small>我已收到录取通知，赴美前需要做好哪些准备？</small>
                </span>
              </a>
            </li>
            <li>
              <a href="#first-days">
                <span class="nav-number">2</span>
                <span>
                  <strong>初到校园（ISSO 支持）</strong>
                  <small>抵达 SCAD 后，我能获得哪些帮助？</small>
                </span>
              </a>
            </li>
            <li>
              <a href="#safety">
                <span class="nav-number">3</span>
                <span>
                  <strong>校园安全</strong>
                  <small>SCAD 如何保障我的学习与生活安全？</small>
                </span>
              </a>
            </li>
            <li>
              <a href="#campus-life">
                <span class="nav-number">4</span>
                <span>
                  <strong>校园生活</strong>
                  <small>在 SCAD 住宿是怎样的体验？</small>
                </span>
              </a>
            </li>
            <li>
              <a href="#academics">
                <span class="nav-number">5</span>
                <span>
                  <strong>学业规划</strong>
                  <small>谁来帮助我规划课程与学习计划？</small>
                </span>
              </a>
            </li>
            <li>
              <a href="#english">
                <span class="nav-number">6</span>
                <span>
                  <strong>英语学习</strong>
                  <small>担心英语水平跟不上课程，我该怎么办？</small>
                </span>
              </a>
            </li>
            <li>
              <a href="#community">
                <span class="nav-number">7</span>
                <span>
                  <strong>融入校园</strong>
                  <small>如何更快融入 SCAD 大家庭？</small>
                </span>
              </a>
            </li>
            <li>
              <a href="#career">
                <span class="nav-number">8</span>
                <span>
                  <strong>职业发展</strong>
                  <small>我该从何时开始准备实习与职业发展？</small>
                </span>
              </a>
            </li>
            <li>
              <a href="#why-scad">
                <span class="nav-number">9</span>
                <span>
                  <strong>为什么选择 SCAD</strong>
                  <small>SCAD 与其他大学相比，独特之处在哪里？</small>
                </span>
              </a>
            </li>
            <li>
              <a href="#family">
                <span class="nav-number">10</span>
                <span>
                  <strong>家庭支持</strong>
                  <small>我的家人如有疑问，该如何联系 SCAD？</small>
                </span>
              </a>
            </li>
          </ol>
        </nav>

        <div class="faq-sections">
          <article id="before-you-leave" class="faq-section">
            <div class="section-heading">
              <span class="section-number">1</span>
              <div>
                <p>行前准备</p>
                <h2>我已收到录取通知，赴美前需要做好哪些准备？</h2>
              </div>
            </div>

            <div class="section-content">
              <div class="content-block">
                <p>
                  在正式抵达 SCAD 之前，专属<strong
                    >招生官（Admission Adviser）</strong
                  >将是你最主要的联络人。从收到录取通知到正式入学，他们会全程陪伴并协助你完成各项准备工作。
                </p>
              </div>

              <div class="content-block">
                <h3 class="content-heading">招生官将协助你：</h3>
                <ul>
                  <li>办理入学相关手续</li>
                  <li>明确后续重要时间节点及安排</li>
                  <li>指导你做好迎新活动的各项准备</li>
                  <li>协助规划赴美行程及校园入住事宜</li>
                  <li>在需要时，帮助你与 SCAD 相关部门建立联系</li>
                </ul>
              </div>

              <div class="content-block">
                <h3 class="content-heading">
                  在此期间，你还将陆续收到关于以下事项的正式通知：
                </h3>
                <ul>
                  <li>迎新活动安排</li>
                  <li>行前准备事项</li>
                  <li>校园入住流程</li>
                  <li>第一学季开学相关事宜</li>
                </ul>
              </div>

              <div class="checklist-block">
                <p class="content-label"><strong>出发前</strong></p>
                <p><strong>在第一学季开始前，请确认已完成以下事项：</strong></p>
                <ul>
                  <li>与招生官保持联系</li>
                  <li>完成所有入学手续</li>
                  <li>定期查看 SCAD 邮箱</li>
                  <li>提交 SCADbound International 申请表</li>
                  <li>登录 MySCAD 查看课程安排</li>
                  <li>根据学校通知确认入住安排</li>
                </ul>
              </div>

              <div class="checklist-block">
                <p class="content-label"><strong>抵达 SCAD 后</strong></p>
                <p><strong>建议尽快完成以下事项：</strong></p>
                <ul>
                  <li>
                    下载 LiveSafe 校园安全 APP（参阅本指南第 3
                    部分<strong>“校园安全”</strong>）
                  </li>
                  <li>
                    参加 SCADbound International 迎新以及 Club Connect
                    学生社团组织活动（参阅本指南第 2
                    部分<strong>“初到校园”</strong>和第 7
                    部分<strong>“融入校园”</strong>）
                  </li>
                  <li>
                    与学生事务顾问及职业顾问完成第一次交流，开启学业与职业发展规划（参阅本指南第
                    5 部分<strong>“学业规划”</strong>和第 8
                    部分<strong>“职业发展”</strong>）
                  </li>
                  <li>
                    关于学生入学后家校沟通的相关政策与方式，请参阅本指南第 10
                    部分<strong>“家庭支持”</strong>
                  </li>
                </ul>
              </div>

              <aside class="tip-block">
                <div class="tip-heading">
                  <img
                    class="tip-logo"
                    :src="artTheBeeLogo"
                    alt=""
                    aria-hidden="true"
                  />
                  <strong>Art T. Bee 温馨提示</strong>
                </div>
                <p>
                  如有任何问题，建议优先联系招生官。他们不仅能够直接为你答疑解惑，还将协助你对接最合适的
                  SCAD 相关部门，确保你获得及时、准确的帮助。
                </p>
              </aside>
            </div>
          </article>

          <article id="first-days" class="faq-section">
            <div class="section-heading">
              <span class="section-number">2</span>
              <div>
                <p>初到校园（ISSO 支持）</p>
                <h2>抵达 SCAD 后，我能获得哪些帮助？</h2>
              </div>
            </div>

            <div class="section-content">
              <div class="content-block">
                <p>
                  从你开始准备赴美的那一刻起，<strong>国际学生服务办公室（ISSO）</strong>就将成为你在
                  SCAD
                  学习期间最重要的支持部门之一，持续为国际学生提供指导与帮助。
                </p>
              </div>

              <div class="content-block">
                <h3 class="content-heading">ISSO 可以为你提供以下支持：</h3>
                <ul>
                  <li>出入境及签证相关规定解读</li>
                  <li>F-1 签证的合规要求</li>
                  <li>医疗保险计划与使用指导</li>
                  <li>校园及周边交通信息</li>
                  <li>跨文化适应与心理调适建议</li>
                  <li>在美工作许可及实习相关事宜</li>
                </ul>
              </div>

              <div class="content-block">
                <p>
                  初抵美国时，你可能会对就医途径、签证身份维持、学业与生活适应等问题产生顾虑。别担心，这些都是国际学生普遍关注的事项。ISSO
                  将全程为你提供专业咨询与切实帮助，助你平稳过渡，安心开启留学新篇章。
                </p>
              </div>

              <h3 class="content-heading">你的首次 ISSO 活动</h3>

              <div class="content-block">
                <p>
                  <strong>SCADbound International</strong>
                  国际新生迎新活动，将正式拉开入学旅程的序幕。
                </p>
              </div>

              <div class="content-block">
                <p class="content-label">
                  <strong
                    >出发前，请完成
                    <a
                      href="https://forms.office.com/Pages/ResponsePage.aspx?id=z3YZhenAv0WD-XpWraXr6fQ1udFjkCFNn_q2UcHS-QpUODJQMFlGQTdVTUlXUElXMTAxU0lZTE9XQS4u"
                      target="_blank"
                      ><b>SCADbound International 申请表</b></a
                    >填写：</strong
                  >
                </p>
                <p>
                  ISSO
                  将根据你提供的信息提前做好准备工作，并在条件允许时安排机场接驳服务等事宜。
                </p>
              </div>

              <div class="content-block">
                <h3 class="content-heading">
                  参加 SCADbound International 后，你将能够：
                </h3>
                <ul>
                  <li>了解如何维持合法签证身份</li>
                  <li>熟悉校园各项资源与服务</li>
                  <li>认识 ISSO 工作人员</li>
                  <li>结识来自世界各地的新同学，拓展国际社交网络</li>
                </ul>
              </div>

              <aside class="tip-block">
                <div class="tip-heading">
                  <img
                    class="tip-logo"
                    :src="artTheBeeLogo"
                    alt=""
                    aria-hidden="true"
                  />
                  <strong>Art T. Bee 温馨提示</strong>
                </div>
                <p>
                  请务必按时提交
                  <a
                    href="https://forms.office.com/Pages/ResponsePage.aspx?id=z3YZhenAv0WD-XpWraXr6fQ1udFjkCFNn_q2UcHS-QpUODJQMFlGQTdVTUlXUElXMTAxU0lZTE9XQS4u"
                    target="_blank"
                    ><b>SCADbound International 申请表</b></a
                  >，并定期查看你的 SCAD 邮箱，及时获取 ISSO
                  发布的重要通知、截止日期和最新安排。
                </p>
              </aside>
            </div>
          </article>

          <article id="safety" class="faq-section">
            <div class="section-heading">
              <span class="section-number">3</span>
              <div>
                <p>校园安全</p>
                <h2>SCAD 如何保障我的学习与生活安全？</h2>
              </div>
            </div>

            <div class="section-content">
              <div class="content-block">
                <p>
                  SCAD
                  致力于为学生营造安全、安心的学习与生活环境，确保每位学生都能专注于学习和创作。<strong
                    >校园安全中心（Department of University Safety）</strong
                  >为学生提供贯穿整个校园生活的安全保障与支持服务。
                </p>
              </div>

              <div class="content-block">
                <h3 class="content-heading">校园安全中心提供的服务包括：</h3>
                <ul>
                  <li>
                    <a
                      href="https://www.scad.edu/life/safety-and-security/livesafe"
                      target="_blank"
                      ><b>LiveSafe 校园安全 APP</b></a
                    >
                  </li>
                  <li>SCAD Bee Line 校车服务</li>
                  <li>SafeRide 夜间护送服务</li>
                  <li>SCAD Alert 紧急通知系统</li>
                  <li>校园安保团队全天候支持</li>
                </ul>
              </div>

              <div class="content-block">
                <p>
                  与此同时，校园安全中心与当地警方、消防部门及其他应急救援机构保持紧密协作，共同维护校园及周边区域的安全秩序。
                </p>
              </div>

              <aside class="tip-block">
                <div class="tip-heading">
                  <img
                    class="tip-logo"
                    :src="artTheBeeLogo"
                    alt=""
                    aria-hidden="true"
                  />
                  <strong>Art T. Bee 温馨提示</strong>
                </div>
                <p>
                  建议你在入学第一周下载
                  <a
                    href="https://www.scad.edu/life/safety-and-security/livesafe"
                    target="_blank"
                    ><b>LiveSafe APP</b></a
                  >，并将校园安全中心的联系方式保存到手机中，以便在需要时能够第一时间获得帮助。
                </p>
              </aside>
            </div>
          </article>

          <article id="campus-life" class="faq-section">
            <div class="section-heading">
              <span class="section-number">4</span>
              <div>
                <p>校园生活</p>
                <h2>在 SCAD 住宿是怎样的体验？</h2>
              </div>
            </div>

            <div class="section-content">
              <div class="content-block">
                <p>
                  对于许多国际学生来说，这是第一次独自在海外生活。<strong
                    >SCADhome</strong
                  >
                  将帮助你更快适应新环境，融入校园社区，开启充实而愉快的大学生活。
                </p>
              </div>

              <div class="content-block">
                <h3 class="content-heading">通过 SCADhome，你可以：</h3>
                <ul>
                  <li>结识新朋友，拓展社交圈</li>
                  <li>与同专业同学建立联系</li>
                  <li>了解校园资源</li>
                  <li>参与学生公寓社区活动</li>
                  <li>更快融入 SCAD 校园生活</li>
                </ul>
              </div>

              <div class="content-block">
                <p>
                  学生公寓负责人和 SCADhome Mentor
                  将在整个学年持续为你提供支持，协助你解决学习和生活中遇到的各类问题。学生公寓汇聚了来自不同国家和文化背景的学生，让国际学生从入住第一天起，就有机会结识来自世界各地的同学，建立友谊，感受多元文化的校园氛围。
                </p>
              </div>

              <aside class="tip-block">
                <div class="tip-heading">
                  <img
                    class="tip-logo"
                    :src="artTheBeeLogo"
                    alt=""
                    aria-hidden="true"
                  />
                  <strong>Art T. Bee 温馨提示</strong>
                </div>
                <p>
                  在预订机票前，请务必先确认学校规定的官方入住日期。抵达校园后，如遇到任何生活上的问题，都可以第一时间向你的
                  SCADhome Mentor 寻求帮助。
                </p>
              </aside>
            </div>
          </article>

          <article id="academics" class="faq-section">
            <div class="section-heading">
              <span class="section-number">5</span>
              <div>
                <p>学业规划</p>
                <h2>谁来帮助我规划课程与学习计划？</h2>
              </div>
            </div>

            <div class="section-content">
              <div class="content-block">
                <p>
                  你的学业规划从入学前就已经开始，并将贯穿整个大学阶段。SCAD
                  根据学习阶段提供分层级的学术支持服务，确保你在每一环节均获得充分指导。
                </p>
              </div>

              <h3 class="content-heading">第一学季</h3>

              <div class="content-block">
                <p class="content-label">
                  <strong
                    >第一学季的课程将由学校统一安排，无需自行选课或进行课程注册。课程安排将综合以下因素制定：</strong
                  >
                </p>
                <ul>
                  <li>你所就读专业</li>
                  <li>当季课程开放情况</li>
                  <li>学校建议的课程修读顺序</li>
                </ul>
              </div>

              <h3 class="content-heading">
                学生事务顾问（Student Success Adviser）
              </h3>

              <div class="content-block">
                <p class="content-label">
                  <strong
                    >在后续学习过程中，学生事务顾问将持续为你提供学业指导，帮助你：</strong
                  >
                </p>
                <ul>
                  <li>了解学位要求</li>
                  <li>规划后续学季课程</li>
                  <li>确保修读进度符合培养方案，按时完成学业</li>
                  <li>对接各类学术支持资源</li>
                </ul>
              </div>

              <h3 class="content-heading">第一学季你将经历什么？</h3>

              <div class="content-block">
                <p>
                  <strong>本科一年级新生</strong>将修读
                  <a
                    href="https://www.scad.edu/life/student-services/undergraduate-advising/first-year-experience"
                    target="_blank"
                    ><strong>First Year Experience（FYE）</strong></a
                  >课程，帮助你熟悉大学学习方式，并全面了解 SCAD
                  的各项学习资源与校园支持服务。
                </p>
              </div>

              <div class="content-block">
                <p>
                  <strong>转学生及研究生</strong
                  >将直接与学生事务顾问会面，了解后续课程注册流程及个人学业规划事宜。
                </p>
              </div>

              <aside class="tip-block">
                <div class="tip-heading">
                  <img
                    class="tip-logo"
                    :src="artTheBeeLogo"
                    alt=""
                    aria-hidden="true"
                  />
                  <strong>Art T. Bee 温馨提示</strong>
                </div>
                <p>
                  入学前，招生官会指导你如何通过
                  <strong>MySCAD</strong>
                  查看课程安排。开学后，请积极与学生事务顾问保持沟通，他们将全程协助你制定后续课程计划，确保你按照既定目标顺利完成学业。
                </p>
              </aside>
            </div>
          </article>

          <article id="english" class="faq-section">
            <div class="section-heading">
              <span class="section-number">6</span>
              <div>
                <p>英语学习</p>
                <h2>担心英语水平跟不上课程，我该怎么办？</h2>
              </div>
            </div>

            <div class="section-content">
              <div class="content-block">
                <p>
                  很多国际学生在入学前都会有这样的担心。<strong
                    >SCAD 英语语言学习支持中心（SCAD Language
                    Studio，SLS）</strong
                  >将帮助学生提升在课堂学习和未来职业发展中所需的英语沟通能力，更自信地适应全英文学习与生活环境。
                </p>
              </div>

              <div class="content-block">
                <h3 class="content-heading">SLS 将协助你：</h3>
                <ul>
                  <li>提升英语沟通能力，增强表达自信</li>
                  <li>为课堂展演做好准备</li>
                  <li>提升学术写作能力</li>
                  <li>更自信地参与作品讲评和课堂讨论</li>
                  <li>锻炼专业语境下的沟通技巧与表达方式</li>
                </ul>
              </div>

              <div class="content-block">
                <p>
                  SLS
                  的指导不仅聚焦于语言本身，更注重培养学生在设计与创意行业中的专业交流能力，确保学生在学术与职业道路上均具备扎实的沟通基础。
                </p>
              </div>

              <h3 class="content-heading">英语能力评估测试</h3>

              <div class="content-block">
                <p class="content-label">
                  <strong
                    >需要英语语言支持课程的学生，在抵达 SCAD
                    后将参加英语能力评估测试。测试内容包括：</strong
                  >
                </p>
                <ul>
                  <li>写作</li>
                  <li>选择题（语法、听力、阅读等）</li>
                  <li>口语</li>
                </ul>
              </div>

              <div class="content-block">
                <h3 class="content-heading">根据测试结果，你可能：</h3>
                <ul>
                  <li>直接免修 SLS 课程（即已达到语言要求）</li>
                  <li>被安排至与当前英语水平相匹配的课程层级</li>
                </ul>
              </div>

              <div class="content-block">
                <p>
                  此外，已安排修读 SLS
                  课程的学生将在开学第一周再次参加评估测试，以便进一步确认课程分班的公平性，确保你获得最适合的语言支持。
                </p>
              </div>

              <aside class="tip-block">
                <div class="tip-heading">
                  <img
                    class="tip-logo"
                    :src="artTheBeeLogo"
                    alt=""
                    aria-hidden="true"
                  />
                  <strong>Art T. Bee 温馨提示</strong>
                </div>
                <p>
                  即使英语不是你的母语，也无需过度担忧。SLS
                  将循序渐进地帮助你建立语言自信，提升课堂展示、学术写作、日常交流等多方面能力，让你更快适应
                  SCAD 的学习节奏与生活环境。
                </p>
              </aside>
            </div>
          </article>

          <article id="community" class="faq-section">
            <div class="section-heading">
              <span class="section-number">7</span>
              <div>
                <p>融入校园</p>
                <h2>如何更快融入 SCAD 大家庭？</h2>
              </div>
            </div>

            <div class="section-content">
              <div class="content-block">
                <p>
                  大学生活不仅是学术探索的过程，更是建立人际网络、发掘兴趣与归属感的重要阶段。SCAD
                  为学生提供了丰富多样的校园活动与交流平台，帮助你快速找到归属感。
                </p>
              </div>

              <h3 class="content-heading">体验校园传统与多元文化</h3>

              <div class="content-block">
                <p>
                  每年，SCAD
                  都会举办丰富多彩的校园文化活动，与来自世界各地的同学共同庆祝不同国家和地区的传统节日与文化。
                </p>
              </div>

              <div class="content-block">
                <h3 class="content-heading">
                  对于中国学生而言，SCAD 中国学生会（CSA）将成为重要的支持平台：
                </h3>
                <ul>
                  <li>共庆中国传统节日</li>
                  <li>结识更多中国同学</li>
                  <li>参与迎新活动</li>
                  <li>与中国学生社群保持联系</li>
                </ul>
              </div>

              <h3 class="content-heading">从 Club Connect 开始</h3>

              <div class="content-block">
                <p class="content-label">
                  <strong
                    >Club Connect 是了解 SCAD
                    校园社团与学生组织的第一站。在这里，你可以与学生组织负责人面对面交流，了解
                    SCAD 100 多个学生社团及组织，包括：</strong
                  >
                </p>
                <ul>
                  <li>各类创意专业学生组织</li>
                  <li>多元文化组织</li>
                  <li>志愿者服务</li>
                  <li>创业创新</li>
                  <li>休闲娱乐活动</li>
                  <li>兴趣类社团</li>
                </ul>
              </div>

              <h3 class="content-heading">探索你的学术兴趣</h3>

              <div class="content-block">
                <p class="content-label">
                  <strong
                    >参加 SCAD 专业和辅修专业展会（Majors and
                    Minors）你可以：</strong
                  >
                </p>
                <ul>
                  <li>与各专业教授面对面交流</li>
                  <li>结识来自不同专业的同学</li>
                  <li>欣赏优秀学生作品与成果</li>
                  <li>了解 SCAD 跨学科培养模式</li>
                </ul>
              </div>

              <div class="content-block">
                <p>
                  符合条件的学生，还可以借此机会正式确认主修专业，为后续学业规划奠定基础。
                </p>
              </div>

              <h3 class="content-heading">积累校园领导力与实践经验</h3>

              <div class="content-block">
                <p class="content-label">
                  <strong>随着你逐渐融入校园，你还有机会申请担任：</strong>
                </p>
                <ul>
                  <li>学生大使（Student ambassador）</li>
                  <li>同伴导师（Peer tutor）</li>
                  <li>实验室管理员（Lab monitor）</li>
                  <li>学生员工（Student employee）</li>
                  <li>院系内容创作者（Departmental content creator）</li>
                </ul>
              </div>

              <div class="content-block">
                <p>
                  以上经历不仅能有效提升个人领导力与职业素养，同时也有助于增强
                  SCAD 社区的活力与凝聚力。
                </p>
              </div>

              <aside class="tip-block">
                <div class="tip-heading">
                  <img
                    class="tip-logo"
                    :src="artTheBeeLogo"
                    alt=""
                    aria-hidden="true"
                  />
                  <strong>Art T. Bee 温馨提示</strong>
                </div>
                <p>
                  建议在开学后的前几周积极参加 Club
                  Connect，大胆尝试感兴趣的活动。很多珍贵的友谊，往往始于主动参与和开放心态。
                </p>
              </aside>
            </div>
          </article>

          <article id="career" class="faq-section">
            <div class="section-heading">
              <span class="section-number">8</span>
              <div>
                <p>职业发展</p>
                <h2>我该从何时开始准备实习与职业发展？</h2>
              </div>
            </div>

            <div class="section-content">
              <div class="content-block">
                <p>
                  在
                  SCAD，职业规划自在校期间即已启动。学校鼓励学生尽早了解行业、明确职业方向，并逐步积累实践经验，为未来职业发展做好准备。
                </p>
              </div>

              <div class="content-block">
                <h3 class="content-heading">
                  职业与校友发展中心（CAS）将为你提供全方位支持：
                </h3>
                <ul>
                  <li>探索职业发展方向</li>
                  <li>提升职业素养</li>
                  <li>优化个人简历</li>
                  <li>打造专业水准的作品集</li>
                  <li>对接企业资源与行业人脉</li>
                  <li>规划实习及长期职业发展</li>
                </ul>
              </div>

              <div class="content-block">
                <h3 class="content-heading">此外，学生还可以参加以下活动：</h3>
                <ul>
                  <li>职业发展讲座及工作坊</li>
                  <li>企业招聘宣讲会</li>
                  <li>校友交流活动</li>
                  <li>一对一职业咨询</li>
                  <li>SCAD Student Employment Job Fair 校内工作招聘会</li>
                </ul>
              </div>

              <div class="content-block">
                <p>
                  SCAD
                  以职业导向为核心特色，自入学首日起即将作品集积累、行业资源对接与职业指导贯穿于人才培养全过程。CAS
                  依托行业资源、职业指导、作品集辅导及实习支持，助力学生在整个大学阶段持续提升专业竞争力。
                </p>
              </div>

              <h3 class="content-heading">校内工作机会</h3>

              <div class="content-block">
                <p>
                  持 F-1
                  签证的国际学生，自第一学季起即可根据相关规定申请校内工作机会。
                </p>
              </div>

              <div class="content-block">
                <p class="content-label">
                  <strong
                    >获得校内工作机会后，校内工作服务中心（Student
                    Employment）和 ISSO 将协助符合条件的学生：</strong
                  >
                </p>
                <ul>
                  <li>申请美国社保卡（Social Security Card）</li>
                  <li>完成在美国合法工作的相关手续</li>
                </ul>
              </div>

              <div class="content-block">
                <p>
                  如果计划从事自由职业、远程工作、合同工作或校外工作，请务必提前咨询
                  ISSO。不同签证身份及工作类型适用不同规定，未经确认请勿自行接受相关职位。
                </p>
              </div>

              <aside class="tip-block">
                <div class="tip-heading">
                  <img
                    class="tip-logo"
                    :src="artTheBeeLogo"
                    alt=""
                    aria-hidden="true"
                  />
                  <strong>Art T. Bee 温馨提示</strong>
                </div>
                <p>
                  建议第一学季就注册
                  <a href="https://scad.12twenty.com/" target="_blank"
                    ><strong>12twenty 平台</strong></a
                  >，认识你的职业顾问（Career
                  Adviser），并预约一次一对一职业咨询。越早启动职业规划，就越有充足的时间积累实践经验，为未来实习和就业做好准备。
                </p>
              </aside>
            </div>
          </article>

          <article id="why-scad" class="faq-section">
            <div class="section-heading">
              <span class="section-number">9</span>
              <div>
                <p>为什么选择 SCAD</p>
                <h2>SCAD 与其他大学相比，独特之处在哪里？</h2>
              </div>
            </div>

            <div class="section-content">
              <div class="content-block">
                <p>
                  SCAD
                  将学术教育与实践导向的创意教学深度融合，打造以行业需求为导向的人才培养模式。在这里，你不仅能够向经验丰富的教授学习，还将与不同专业的同学开展跨专业合作，并在学习过程中持续打造符合行业标准的专业作品集。
                </p>
              </div>

              <div class="content-block">
                <p>
                  从入学第一天开始，SCAD
                  就通过丰富的行业资源和完善的职业发展支持体系，帮助学生为未来进入创意行业做好准备。
                </p>
              </div>
            </div>
          </article>

          <article id="family" class="faq-section">
            <div class="section-heading">
              <span class="section-number">10</span>
              <div>
                <p>家庭支持</p>
                <h2>我的家人如有疑问，该如何联系 SCAD？</h2>
              </div>
            </div>

            <div class="section-content">
              <div class="content-block">
                <p>
                  如果家长对
                  SCAD、迎新活动或校园生活等有任何疑问，欢迎联系学生的招生官进行咨询。
                </p>
              </div>

              <div class="content-block">
                <p>
                  学生正式入学后，美国联邦法律
                  <strong>FERPA（《家庭教育权利和隐私法》）</strong
                  >将依法保护学生的教育记录和个人信息。因此，只有在学生本人授权同意的情况下，SCAD
                  才能向家长或其他家庭成员提供与学生个人学习或相关事务有关的信息。如果学生希望家长能够参与并了解自己的学习情况，招生官将协助学生完成相关授权手续。
                </p>
              </div>
            </div>
          </article>
        </div>
      </template>

      <template v-else>
        <header class="faq-hero">
          <p class="faq-meta">10 FAQs | About a 15-minute read</p>
          <h1>Starting your SCAD journey</h1>
          <h2>International student FAQ quick guide</h2>
          <div class="faq-introduction-desktop">
            <p class="faq-introduction">
              Whether you're preparing to travel to the U.S. or getting ready
              for your first quarter, these answers will help you understand
              what to expect before you arrive and where to find support once
              you're on campus.
            </p>
            <p class="faq-introduction">
              Starting university in another country is an exciting step, and
              it's natural to have questions along the way, for you and for your
              family. These answers guide you through every stage, from
              preparing to leave home to building your career after graduation.
            </p>
          </div>
        </header>

        <nav class="faq-navigation" aria-label="Quick navigation">
          <h2>Quick navigation</h2>
          <ol>
            <li>
              <a href="#before-you-leave">
                <span class="nav-number">1</span>
                <span>
                  <strong>Before you leave home</strong>
                  <small
                    >I've been admitted. What should I do before I leave for the
                    U.S.?</small
                  >
                </span>
              </a>
            </li>
            <li>
              <a href="#first-days">
                <span class="nav-number">2</span>
                <span>
                  <strong>Your first days at SCAD (ISSO)</strong>
                  <small>Who helps me after I arrive?</small>
                </span>
              </a>
            </li>
            <li>
              <a href="#safety">
                <span class="nav-number">3</span>
                <span>
                  <strong>Staying safe and supported</strong>
                  <small>How does SCAD help keep students safe?</small>
                </span>
              </a>
            </li>
            <li>
              <a href="#campus-life">
                <span class="nav-number">4</span>
                <span>
                  <strong>Making SCAD your home</strong>
                  <small>What is it like living on campus?</small>
                </span>
              </a>
            </li>
            <li>
              <a href="#academics">
                <span class="nav-number">5</span>
                <span>
                  <strong>Succeeding academically</strong>
                  <small>Who helps me plan my classes?</small>
                </span>
              </a>
            </li>
            <li>
              <a href="#english">
                <span class="nav-number">6</span>
                <span>
                  <strong>Building confidence in English</strong>
                  <small>What if I'm nervous about studying in English?</small>
                </span>
              </a>
            </li>
            <li>
              <a href="#community">
                <span class="nav-number">7</span>
                <span>
                  <strong>Finding your community</strong>
                  <small>How do I become part of the SCAD community?</small>
                </span>
              </a>
            </li>
            <li>
              <a href="#career">
                <span class="nav-number">8</span>
                <span>
                  <strong>Preparing for your future career</strong>
                  <small
                    >When should I start preparing for internships and my
                    career?</small
                  >
                </span>
              </a>
            </li>
            <li>
              <a href="#why-scad">
                <span class="nav-number">9</span>
                <span>
                  <strong>Why choose SCAD</strong>
                  <small
                    >What makes studying at SCAD different from other
                    universities?</small
                  >
                </span>
              </a>
            </li>
            <li>
              <a href="#family">
                <span class="nav-number">10</span>
                <span>
                  <strong>Family support</strong>
                  <small
                    >Can my family contact SCAD if they have questions?</small
                  >
                </span>
              </a>
            </li>
          </ol>
        </nav>

        <div class="faq-sections">
          <article id="before-you-leave" class="faq-section">
            <div class="section-heading">
              <span class="section-number">1</span>
              <div>
                <p>Before you leave home</p>
                <h2>
                  I've been admitted. What should I do before I leave for the
                  U.S.?
                </h2>
              </div>
            </div>

            <div class="section-content">
              <div class="content-block">
                <p>
                  Your SCAD admission adviser is your primary point of contact
                  before you arrive. They will guide you from the time you're
                  admitted until you arrive at SCAD.
                </p>
              </div>

              <div class="content-block">
                <h3 class="content-heading">
                  Your admission adviser will help you:
                </h3>
                <ul>
                  <li>Complete your enrollment</li>
                  <li>Understand your next steps</li>
                  <li>Prepare for orientation</li>
                  <li>Plan your travel and move-in</li>
                  <li>
                    Connect you with the appropriate SCAD department when needed
                  </li>
                </ul>
              </div>

              <div class="content-block">
                <h3 class="content-heading">
                  You'll also receive important updates about:
                </h3>
                <ul>
                  <li>Orientation</li>
                  <li>Travel preparation</li>
                  <li>Move-in</li>
                  <li>The start of your first quarter</li>
                </ul>
              </div>

              <div class="checklist-block">
                <p class="content-label">
                  <strong>Before you leave home</strong>
                </p>
                <p>Before your first quarter, make sure you:</p>
                <ul>
                  <li>Stay in contact with your admission adviser</li>
                  <li>Complete your enrollment requirements</li>
                  <li>Check your SCAD email regularly</li>
                  <li>
                    Complete the SCADbound International Participation Report
                  </li>
                  <li>Review your class schedule in MySCAD</li>
                  <li>Prepare for your assigned move-in date</li>
                </ul>
              </div>

              <div class="checklist-block">
                <p class="content-label">
                  <strong>Your first weeks at SCAD</strong>
                </p>
                <ul>
                  <li>Download the LiveSafe app after arriving on campus</li>
                  <li>Attend SCADbound International and Club Connect</li>
                  <li>
                    Meet your Student Success adviser and career adviser during
                    your first quarter
                  </li>
                </ul>
              </div>

              <aside class="tip-block">
                <div class="tip-heading">
                  <img
                    class="tip-logo"
                    :src="artTheBeeLogo"
                    alt=""
                    aria-hidden="true"
                  />
                  <strong>Art T. Bee Tip</strong>
                </div>
                <p>
                  Before contacting another SCAD department, start with your
                  admission adviser. They can answer your questions or connect
                  you with the right office.
                </p>
              </aside>

              <aside class="help-block">
                <p class="help-label">Need help?</p>
                <h3>Admission Adviser</h3>
                <p>Questions about:</p>
                <ul>
                  <li>Enrollment</li>
                  <li>Travel preparation</li>
                  <li>Orientation</li>
                  <li>Pre-arrival planning</li>
                </ul>
              </aside>
            </div>
          </article>

          <article id="first-days" class="faq-section">
            <div class="section-heading">
              <span class="section-number">2</span>
              <div>
                <p>Your first days at SCAD (ISSO)</p>
                <h2>Who helps me after I arrive?</h2>
              </div>
            </div>

            <div class="section-content">
              <div class="content-block">
                <p>
                  From the moment you begin preparing to travel to the U.S., the
                  International Student Services Office (ISSO) becomes one of
                  your primary resources throughout your time at SCAD.
                </p>
              </div>

              <div class="content-block">
                <h3 class="content-heading">ISSO can help with:</h3>
                <ul>
                  <li>Immigration requirements</li>
                  <li>F-1 visa responsibilities</li>
                  <li>Health insurance</li>
                  <li>Transportation</li>
                  <li>Cultural adjustment</li>
                  <li>Employment authorization</li>
                </ul>
              </div>

              <div class="content-block">
                <p>
                  It's normal to wonder what happens if you get sick, how to
                  maintain your visa status, or what everyday life in the U.S.
                  is like. ISSO exists specifically to help with exactly these
                  kinds of questions, so you're never navigating them alone.
                </p>
              </div>

              <h3 class="content-heading">Your first ISSO experience</h3>

              <div class="content-block">
                <p>
                  Your transition begins with
                  <strong>SCADbound International</strong>, SCAD's orientation
                  program for new international students.
                </p>
              </div>

              <div class="content-block">
                <p class="content-label"><strong>Before you arrive</strong></p>
                <p>
                  Complete the
                  <a
                    class="rich-link"
                    href="https://forms.office.com/Pages/ResponsePage.aspx?id=z3YZhenAv0WD-XpWraXr6fQ1udFjkCFNn_q2UcHS-QpUODJQMFlGQTdVTUlXUElXMTAxU0lZTE9XQS4u"
                    target="_blank"
                    rel="noopener noreferrer"
                    ><strong
                      >SCADbound International Participation Report</strong
                    ></a
                  >. This required form helps ISSO prepare for your arrival and
                  coordinate services such as airport shuttle transportation,
                  when applicable.
                </p>
              </div>

              <div class="content-block">
                <h3 class="content-heading">
                  During SCADbound International, you'll:
                </h3>
                <ul>
                  <li>Learn how to maintain your immigration status</li>
                  <li>Become familiar with campus resources</li>
                  <li>Meet ISSO staff</li>
                  <li>Connect with fellow international students</li>
                </ul>
              </div>

              <aside class="tip-block">
                <div class="tip-heading">
                  <img
                    class="tip-logo"
                    :src="artTheBeeLogo"
                    alt=""
                    aria-hidden="true"
                  />
                  <strong>Art T. Bee Tip</strong>
                </div>
                <p>
                  Complete your
                  <a
                    class="rich-link"
                    href="https://forms.office.com/Pages/ResponsePage.aspx?id=z3YZhenAv0WD-XpWraXr6fQ1udFjkCFNn_q2UcHS-QpUODJQMFlGQTdVTUlXUElXMTAxU0lZTE9XQS4u"
                    target="_blank"
                    rel="noopener noreferrer"
                    >SCADbound International Participation Report</a
                  >
                  and check your SCAD email regularly for important arrival
                  requirements, deadlines, and updates from ISSO.
                </p>
              </aside>

              <aside class="help-block">
                <p class="help-label">Need help?</p>
                <h3>International Student Services Office (ISSO)</h3>
                <p>Questions about:</p>
                <ul>
                  <li>Immigration</li>
                  <li>F-1 visa requirements</li>
                  <li>Health insurance</li>
                  <li>Employment authorization</li>
                </ul>
              </aside>
            </div>
          </article>

          <article id="safety" class="faq-section">
            <div class="section-heading">
              <span class="section-number">3</span>
              <div>
                <p>Staying safe and supported</p>
                <h2>How does SCAD help keep students safe?</h2>
              </div>
            </div>

            <div class="section-content">
              <div class="content-block">
                <p>
                  SCAD is committed to providing a safe environment so students
                  can focus on learning and creating. The
                  <strong>Department of University Safety</strong> provides
                  services and resources designed to support students throughout
                  daily campus life.
                </p>
              </div>

              <div class="content-block">
                <h3 class="content-heading">Safety resources include:</h3>
                <ul>
                  <li>
                    <a
                      href="https://www.scad.edu/life/safety-and-security/livesafe"
                      target="_blank"
                      ><b>LiveSafe mobile app</b></a
                    >
                  </li>
                  <li>SCAD Bee Line bus system</li>
                  <li>SafeRide late-night transportation</li>
                  <li>SCAD Alert emergency notifications</li>
                  <li>University Safety staff</li>
                </ul>
              </div>

              <div class="content-block">
                <p>
                  University Safety also works closely with local police, fire,
                  and emergency response agencies.
                </p>
              </div>

              <aside class="tip-block">
                <div class="tip-heading">
                  <img
                    class="tip-logo"
                    :src="artTheBeeLogo"
                    alt=""
                    aria-hidden="true"
                  />
                  <strong>Art T. Bee Tip</strong>
                </div>
                <p>
                  Download the
                  <a
                    href="https://www.scad.edu/life/safety-and-security/livesafe"
                    target="_blank"
                    ><b>LiveSafe app</b></a
                  >
                  during your first week and save University Safety's contact
                  information on your phone.
                </p>
              </aside>

              <aside class="help-block">
                <p class="help-label">Need help?</p>
                <h3>Department of University Safety</h3>
                <p>Questions about:</p>
                <ul>
                  <li>Campus safety</li>
                  <li>Emergency assistance</li>
                  <li>SafeRide</li>
                  <li>SCAD Alert system</li>
                </ul>
              </aside>
            </div>
          </article>

          <article id="campus-life" class="faq-section">
            <div class="section-heading">
              <span class="section-number">4</span>
              <div>
                <p>Making SCAD your home</p>
                <h2>What is it like living on campus?</h2>
              </div>
            </div>

            <div class="section-content">
              <div class="content-block">
                <p>
                  For many international students, living on campus is their
                  first experience living independently in another country.
                  <strong>SCADhome</strong> helps make that transition
                  welcoming, supportive, and engaging.
                </p>
              </div>

              <div class="content-block">
                <h3 class="content-heading">SCADhome helps you:</h3>
                <ul>
                  <li>Build friendships</li>
                  <li>Meet classmates</li>
                  <li>Connect with campus resources</li>
                  <li>Participate in residence hall programs</li>
                  <li>Feel at home in the SCAD community</li>
                </ul>
              </div>

              <div class="content-block">
                <p>
                  Professional community directors and student SCADhome mentors
                  are available to answer questions and provide support
                  throughout the year. Residence halls also bring together
                  students from different cultures and countries, helping
                  international students build friendships and feel connected
                  from their very first days at SCAD.
                </p>
              </div>

              <aside class="tip-block">
                <div class="tip-heading">
                  <img
                    class="tip-logo"
                    :src="artTheBeeLogo"
                    alt=""
                    aria-hidden="true"
                  />
                  <strong>Art T. Bee Tip</strong>
                </div>
                <p>
                  Check the assigned move-in date before booking your travel.
                  Once you arrive, your SCADhome mentor is a great first person
                  to ask if you need help settling in.
                </p>
              </aside>

              <aside class="help-block">
                <p class="help-label">Need help?</p>
                <h3>SCADhome</h3>
                <p>Questions about:</p>
                <ul>
                  <li>Residence halls</li>
                  <li>Move-in</li>
                  <li>Campus living</li>
                  <li>Housing support</li>
                </ul>
              </aside>
            </div>
          </article>

          <article id="academics" class="faq-section">
            <div class="section-heading">
              <span class="section-number">5</span>
              <div>
                <p>Succeeding academically</p>
                <h2>Who helps me plan my classes?</h2>
              </div>
            </div>

            <div class="section-content">
              <div class="content-block">
                <p>
                  Academic planning begins before your first day of class and
                  continues throughout your time at SCAD.
                </p>
              </div>

              <h3 class="content-heading">Your first quarter</h3>

              <div class="content-block">
                <p class="content-label">
                  <strong
                    >SCAD will register you for your first-quarter classes. Your
                    schedule is created based on:</strong
                  >
                </p>
                <ul>
                  <li>Your academic program</li>
                  <li>Course availability</li>
                  <li>The recommended sequence of courses</li>
                </ul>
              </div>

              <div class="content-block">
                <p>
                  There is nothing you need to do to register for your first
                  quarter.
                </p>
              </div>

              <h3 class="content-heading">Student Success advisers</h3>

              <div class="content-block">
                <p class="content-label">
                  <strong>Student Success advisers help you:</strong>
                </p>
                <ul>
                  <li>Understand degree requirements</li>
                  <li>Prepare for future course registration</li>
                  <li>Stay on track toward graduation</li>
                  <li>Connect with academic resources</li>
                </ul>
              </div>

              <h3 class="content-heading">During your first quarter</h3>

              <div class="content-block">
                <p class="content-label">
                  <strong>First-year undergraduate students</strong>
                </p>
                <p>
                  Take a
                  <a
                    href="https://www.scad.edu/life/student-services/undergraduate-advising/first-year-experience"
                    target="_blank"
                    ><strong>First Year Experience (FYE) course</strong></a
                  >
                  that introduces university life and SCAD resources.
                </p>
              </div>

              <div class="content-block">
                <p class="content-label">
                  <strong>Transfer and graduate students</strong>
                </p>
                <p>
                  Meet with their <strong>Student Success adviser</strong> to
                  learn how to register for future quarters.
                </p>
              </div>

              <aside class="tip-block">
                <div class="tip-heading">
                  <img
                    class="tip-logo"
                    :src="artTheBeeLogo"
                    alt=""
                    aria-hidden="true"
                  />
                  <strong>Art T. Bee Tip</strong>
                </div>
                <p>
                  Before you arrive, your admission adviser will show you how to
                  find your class schedule in MySCAD. Once classes begin, your
                  Student Success adviser will help you plan future quarters and
                  stay on track for graduation.
                </p>
              </aside>

              <aside class="help-block">
                <p class="help-label">Need help?</p>
                <h3>Student Success</h3>
                <p>Questions about:</p>
                <ul>
                  <li>Class registration</li>
                  <li>Degree requirements</li>
                  <li>Academic planning</li>
                  <li>Graduation progress</li>
                </ul>
              </aside>
            </div>
          </article>

          <article id="english" class="faq-section">
            <div class="section-heading">
              <span class="section-number">6</span>
              <div>
                <p>Building confidence in English</p>
                <h2>What if I'm nervous about studying in English?</h2>
              </div>
            </div>

            <div class="section-content">
              <div class="content-block">
                <p>
                  Many international students have the same concern before
                  arriving at SCAD. The
                  <strong>SCAD Language Studio (SLS)</strong> helps students
                  develop the communication skills needed to succeed in creative
                  classrooms and professional environments.
                </p>
              </div>

              <div class="content-block">
                <h3 class="content-heading">
                  The SCAD Language Studio (SLS) helps you:
                </h3>
                <ul>
                  <li>Build confidence speaking English</li>
                  <li>Prepare presentations</li>
                  <li>Improve academic writing</li>
                  <li>Participate in critiques</li>
                  <li>Develop professional communication skills</li>
                </ul>
              </div>

              <div class="content-block">
                <p>
                  Rather than focusing only on grammar, SLS prepares students to
                  communicate successfully in design and creative industries.
                </p>
              </div>

              <h3 class="content-heading">English Proficiency Assessment</h3>

              <div class="content-block">
                <p>
                  Students who are required to complete English language support
                  through Admission take an English Proficiency Assessment after
                  arriving at SCAD.
                </p>
              </div>

              <div class="content-block">
                <p class="content-label">
                  <strong>The assessment includes:</strong>
                </p>
                <ul>
                  <li>Writing</li>
                  <li>Multiple-choice questions</li>
                  <li>Speaking</li>
                </ul>
              </div>

              <div class="content-block">
                <h3 class="content-heading">Based on your results, you may:</h3>
                <ul>
                  <li>Be exempt from SLS courses</li>
                  <li>
                    Be placed into the course level that best supports your
                    success
                  </li>
                </ul>
              </div>

              <div class="content-block">
                <p>
                  Students placed into SLS also participate in a diagnostic week
                  during their first week of classes to confirm their placement.
                </p>
              </div>

              <aside class="tip-block">
                <div class="tip-heading">
                  <img
                    class="tip-logo"
                    :src="artTheBeeLogo"
                    alt=""
                    aria-hidden="true"
                  />
                  <strong>Art T. Bee Tip</strong>
                </div>
                <p>
                  Don't worry if English isn't your first language. The SCAD
                  Language Studio is here to help you build confidence in
                  presentations, critiques, research writing, and everyday
                  communication.
                </p>
              </aside>

              <aside class="help-block">
                <p class="help-label">Need help?</p>
                <h3>SCAD Language Studio</h3>
                <p>Questions about:</p>
                <ul>
                  <li>English support</li>
                  <li>Placement assessment</li>
                  <li>Academic communication</li>
                  <li>Presentation skills</li>
                </ul>
              </aside>
            </div>
          </article>

          <article id="community" class="faq-section">
            <div class="section-heading">
              <span class="section-number">7</span>
              <div>
                <p>Finding your community</p>
                <h2>How do I become part of the SCAD community?</h2>
              </div>
            </div>

            <div class="section-content">
              <div class="content-block">
                <p>
                  Your first weeks at SCAD are about more than academics. SCAD
                  offers many opportunities to meet classmates, explore your
                  interests, and become part of the university community.
                </p>
              </div>

              <h3 class="content-heading">Celebrate campus traditions</h3>

              <div class="content-block">
                <p>
                  Throughout the year, students come together to celebrate
                  traditions and cultures from around the world.
                </p>
              </div>

              <div class="content-block">
                <h3 class="content-heading">
                  For Chinese students, the SCAD Chinese Student Association
                  (CSA) offers opportunities to:
                </h3>
                <ul>
                  <li>Celebrate traditional holidays</li>
                  <li>Build friendships</li>
                  <li>Welcome new students</li>
                  <li>Stay connected with the Chinese community</li>
                </ul>
              </div>

              <h3 class="content-heading">Start with Club Connect</h3>

              <div class="content-block">
                <p class="content-label">
                  <strong
                    >Meet student leaders and explore more than 100 student
                    organizations, including:</strong
                  >
                </p>
                <ul>
                  <li>Creative disciplines</li>
                  <li>Cultural organizations</li>
                  <li>Volunteer service</li>
                  <li>Entrepreneurship</li>
                  <li>Recreation</li>
                  <li>Special interest groups</li>
                </ul>
              </div>

              <h3 class="content-heading">Explore your academic interests</h3>

              <div class="content-block">
                <p class="content-label">
                  <strong>Attend the Majors and Minors Fair to:</strong>
                </p>
                <ul>
                  <li>Meet faculty</li>
                  <li>Connect with students from different programs</li>
                  <li>View examples of student work</li>
                  <li>Learn how disciplines connect across SCAD</li>
                </ul>
              </div>

              <div class="content-block">
                <p>
                  Students who are ready may also have the opportunity to
                  declare their major.
                </p>
              </div>

              <h3 class="content-heading">Build leadership experience</h3>

              <div class="content-block">
                <p class="content-label">
                  <strong
                    >As you become involved on campus, you may also have
                    opportunities to serve as a:</strong
                  >
                </p>
                <ul>
                  <li>Student ambassador</li>
                  <li>Peer tutor</li>
                  <li>Lab monitor</li>
                  <li>Student employee</li>
                  <li>Departmental content creator</li>
                </ul>
              </div>

              <div class="content-block">
                <p>
                  These experiences help students develop leadership and
                  professional skills while contributing to the SCAD community.
                </p>
              </div>

              <aside class="tip-block">
                <div class="tip-heading">
                  <img
                    class="tip-logo"
                    :src="artTheBeeLogo"
                    alt=""
                    aria-hidden="true"
                  />
                  <strong>Art T. Bee Tip</strong>
                </div>
                <p>
                  Attend Club Connect during your first few weeks and try
                  something new. Many lifelong friendships begin during your
                  first quarter.
                </p>
              </aside>

              <aside class="help-block">
                <p class="help-label">Need help?</p>
                <h3>Student Involvement</h3>
                <p>Questions about:</p>
                <ul>
                  <li>Student organizations</li>
                  <li>Campus events</li>
                  <li>Leadership opportunities</li>
                  <li>Student engagement</li>
                </ul>
              </aside>
            </div>
          </article>

          <article id="career" class="faq-section">
            <div class="section-heading">
              <span class="section-number">8</span>
              <div>
                <p>Preparing for your future career</p>
                <h2>
                  When should I start preparing for internships and my career?
                </h2>
              </div>
            </div>

            <div class="section-content">
              <div class="content-block">
                <p>
                  Career preparation begins earlier than many students expect.
                  At SCAD, students are encouraged to begin exploring career
                  opportunities during their first quarter.
                </p>
              </div>

              <div class="content-block">
                <h3 class="content-heading">
                  Career and Alumni Success (CAS) helps students:
                </h3>
                <ul>
                  <li>Explore career paths</li>
                  <li>Develop professional skills</li>
                  <li>Prepare résumés</li>
                  <li>Build portfolios</li>
                  <li>Connect with employers</li>
                  <li>Plan internships and future careers</li>
                </ul>
              </div>

              <div class="content-block">
                <h3 class="content-heading">
                  Students can also participate in:
                </h3>
                <ul>
                  <li>Career workshops</li>
                  <li>Employer presentations</li>
                  <li>Alumni networking events</li>
                  <li>One-on-one career advising</li>
                  <li>The SCAD Student Employment Job Fair</li>
                </ul>
              </div>

              <div class="content-block">
                <p>
                  Career and Alumni Success (CAS) helps students build a strong
                  professional foundation from their first year through career
                  advising, portfolio development, employer connections, and
                  internship preparation.
                </p>
              </div>

              <h3 class="content-heading">On-campus employment</h3>

              <div class="content-block">
                <p>
                  International students studying on F-1 visas may be eligible
                  for on-campus employment beginning in their first quarter.
                </p>
              </div>

              <div class="content-block">
                <p class="content-label">
                  After receiving an on-campus job offer, Student Employment and
                  ISSO can help eligible students:
                </p>
                <ul>
                  <li>Apply for a Social Security card</li>
                  <li>
                    Complete the steps required to work in the United States
                  </li>
                </ul>
              </div>

              <div class="content-block">
                <p>
                  Before accepting freelance, remote, contract, or off-campus
                  work, consult ISSO because employment authorization rules vary
                  by visa status and type of work.
                </p>
              </div>

              <aside class="tip-block">
                <div class="tip-heading">
                  <img
                    class="tip-logo"
                    :src="artTheBeeLogo"
                    alt=""
                    aria-hidden="true"
                  />
                  <strong>Art T. Bee Tip</strong>
                </div>
                <p>
                  Create your
                  <a href="https://scad.12twenty.com/" target="_blank"
                    ><b>12twenty</b></a
                  >
                  account, meet your career adviser, and schedule a one-on-one
                  appointment during your first quarter. Starting early gives
                  you more time to build experience before graduation.
                </p>
              </aside>

              <aside class="help-block">
                <p class="help-label">Need help?</p>
                <h3>Career and Alumni Success (CAS)</h3>
                <p>Questions about:</p>
                <ul>
                  <li>Career advising</li>
                  <li>Internships</li>
                  <li>Résumés</li>
                  <li>Portfolios</li>
                  <li>Student employment</li>
                </ul>
              </aside>
            </div>
          </article>

          <article id="why-scad" class="faq-section">
            <div class="section-heading">
              <span class="section-number">9</span>
              <div>
                <p>Why choose SCAD</p>
                <h2>
                  What makes studying at SCAD different from other universities?
                </h2>
              </div>
            </div>

            <div class="section-content">
              <div class="content-block">
                <p>
                  SCAD combines rigorous academic study with hands-on,
                  studio-based creative learning. Students work alongside
                  experienced faculty, collaborate across disciplines, and build
                  professional portfolios designed specifically for creative
                  careers, supported by industry connections and career advising
                  from day one.
                </p>
              </div>
            </div>
          </article>

          <article id="family" class="faq-section">
            <div class="section-heading">
              <span class="section-number">10</span>
              <div>
                <p>Family support</p>
                <h2>Can my family contact SCAD if they have questions?</h2>
              </div>
            </div>

            <div class="section-content">
              <div class="content-block">
                <p>
                  Yes. Families are welcome to reach out to a student's
                  admission adviser with general questions about SCAD,
                  orientation, and campus life.
                </p>
              </div>

              <div class="content-block">
                <p>
                  Once a student enrolls, U.S. privacy law protects their
                  education records. SCAD can discuss a student's academic or
                  personal information with family members only when the student
                  has provided permission. The admission adviser can explain how
                  to complete this process.
                </p>
              </div>
            </div>
          </article>
        </div>
      </template>
    </main>

    <goTop />
    <custFooter />
  </div>
</template>

<script>
import menuBar from "../../components/menuBar/index.vue";
import custFooter from "@/components/footer/Footer";
import artTheBeeLogo from "@/assets/images/artthebee.jpg";

export default {
  name: "Faq",
  components: {
    menuBar,
    custFooter,
  },
  data() {
    return {
      artTheBeeLogo,
    };
  },
  computed: {
    isChinese() {
      return this.$i18n.locale === "zh";
    },
  },
  metaInfo() {
    return {
      title: `${
        this.isChinese ? "开启 SCAD 之旅" : "Starting Your SCAD Journey"
      } | SCAD`,
    };
  },
};
</script>

<style scoped lang="less">
@import "Faq.less";
</style>
